import type { ChatTimelineItem } from './chat-sync.js';

export const deletedConversationName = 'Удалённый пользователь';

export function isUnavailableConversation(displayName: string) {
  return displayName === deletedConversationName;
}

export function chatItemText(item: ChatTimelineItem) {
  if (item.kind === 'SYSTEM') return 'Событие беседы';
  return item.text ?? 'Сообщение удалено';
}

export function chatItemTime(value: string | undefined): string | undefined {
  if (!value) return undefined;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return undefined;
  return new Intl.DateTimeFormat('ru-RU', { hour: '2-digit', minute: '2-digit' }).format(date);
}
